module.exports = __webpack_public_path__ + "static/img/safety.60c596b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/safety.png
// module id = sbYV
// module chunks = 1